// extracted by mini-css-extract-plugin
module.exports = {"drawer":"styles_drawer__5APCJ","actionBtn":"styles_actionBtn__L02pM","unclaimed":"styles_unclaimed__ljcu0"};